export const UPDATE = 'LAST_VISITED_PAGE_UPDATE';